import { useEffect, useState } from 'preact/hooks';
export const useCart = ()=>{
    const [cart, setCart] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        setLoading(true);
        fetch('/cart.js').then((r)=>r.json()).then(setCart).catch(()=>setCart(null)).finally(()=>setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        cart,
        loading
    };
};
